<template>
  <v-container fluid v-if="asyncDataStatus_ready">
    <div class="dashboard-page">
      <v-card width="100%" class="breadcrumbs mx-1 mb-6">
        <v-row no-gutters class="d-flex align-center mt-8 mb-3 px-5 py-1 mx-1">
          <v-col
            cols="12"
            md="6"
            class="d-sm-flex justify-md-start justify-space-between align-center"
          >
            <h1 class="main-page-title greyMedium--text mb-0 mr-2 pt-4 pt-md-0">
              Relatórios de Pessoas Alcançadas
            </h1>
            <div class="py-6"></div>
          </v-col>
          <v-col
            cols="12"
            md="6"
            class="d-sm-flex justify-space-between align-center justify-md-end"
          >
            <v-chip class="ma-2 py-8 pl-4 pr-4" color="green" text-color="white" large>
              <v-avatar
                style="height: 55px !important; width: 55px !important"
                left
                class="green darken-4"
              >
                <strong>{{ this.listaPessoasAlcancadas.length }}</strong>
              </v-avatar>
              <strong>Total de Pessoas Alcançadas</strong>
            </v-chip>          
          </v-col>
        </v-row>
      </v-card>

      <v-card width="100%" class="mx-1 mb-6">
        <v-row no-gutters class="d-flex align-center mt-8 mb-3 px-5 py-1 mx-1">
          <v-col
            cols="12"
            md="6"
            class="d-sm-flex justify-md-start justify-space-between align-center"
          >
            <h6 class="greyMedium--text mb-0 mr-2 pt-4 pt-md-0">
              Pessoas Alcançadas por Estado
            </h6>
            <div class="py-6"></div>
          </v-col>

          <v-col cols="8">
            <ApexChart
              type="bar"
              height="350"
              :options="mockPessoas.apexBarPorEstado.options"
              :series="mockPessoas.apexBarPorEstado.series"
            ></ApexChart>
          </v-col>

          <v-col cols="4">
            <ApexChart
              type="pie"
              :options="mockPessoas.apexPiePorEstado1.options"
              :series="mockPessoas.apexPiePorEstado1.series"
            ></ApexChart>
          </v-col>

          <v-col
            cols="12"
            md="6"
            class="d-sm-flex justify-space-between align-center justify-md-end"
          >
          </v-col>
        </v-row>
      </v-card>

      <v-card width="100%" class="mx-1 mb-6">
        <v-row no-gutters class="d-flex align-center mt-8 mb-3 px-5 py-1 mx-1">
          <v-col
            cols="12"
            md="6"
            class="d-sm-flex justify-md-start justify-space-between align-center"
          >
            <h6 class="greyMedium--text mb-0 mr-2 pt-4 pt-md-0">
              Pessoas Alcançadas por Gênero
            </h6>
            <div class="py-6"></div>
          </v-col>

          <v-col cols="8">
            <ApexChart
              type="bar"
              height="350"
              :options="mockPessoas.apexBarPorGenero.options"
              :series="mockPessoas.apexBarPorGenero.series"
            ></ApexChart>
          </v-col>

          <v-col cols="4">
            <ApexChart
              type="pie"
              :options="mockPessoas.apexPiePorGenero.options"
              :series="mockPessoas.apexPiePorGenero.series"
            ></ApexChart>
          </v-col>

          <v-col
            cols="12"
            md="6"
            class="d-sm-flex justify-space-between align-center justify-md-end"
          >
          </v-col>
        </v-row>
      </v-card>

      <v-card width="100%" class="mx-1 mb-6">
        <v-row no-gutters class="d-flex align-center mt-8 mb-3 px-5 py-1 mx-1">
          <v-col
            cols="12"
            md="6"
            class="d-sm-flex justify-md-start justify-space-between align-center"
          >
            <h6 class="greyMedium--text mb-0 mr-2 pt-4 pt-md-0">
              Pessoas Alcançadas por Faixa Etária
            </h6>
            <div class="py-6"></div>
          </v-col>

          <v-col cols="12">
            <ApexChart
              type="bar"
              height="350"
              :options="mockPessoas.apexBarPorIdade.options"
              :series="mockPessoas.apexBarPorIdade.series"
            ></ApexChart>
          </v-col>

          <v-col
            cols="12"
            md="6"
            class="d-sm-flex justify-space-between align-center justify-md-end"
          >
          </v-col>
        </v-row>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import asyncDataStatus from "@/mixins/asyncDataStatus";
import mockPessoas from "./mockPessoas";
import ApexChart from "vue-apexcharts";

export default {
  name: "Pessoas",
  components: {
    ApexChart,
  },
  mixins: [asyncDataStatus],
  data() {
    return {
      mockPessoas,
      barChartOptionsPorEstado: {
        chart: {
          id: "bar-chart",
        },
        xaxis: {
          categories: [], // serão preenchidos dinamicamente
        },
      },
      barChartSeriesPorEstado: [
        {
          name: "Pessoas",
          data: [], // serão preenchidos dinamicamente
        },
      ],

      options: {
        chart: {
          id: "vuechart-example",
        },
        xaxis: {
          categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998],
        },
      },
      series: [
        {
          name: "series-1",
          data: [30, 40, 45, 50, 49, 60, 70, 91],
        },
      ],
    };
  },
  methods: {
    ...mapActions("pessoaAlcancada", [
      "fetchPessoasAlcancadasByProjeto",
      "deletePessoaAlcancada",
    ]),
    maximo(mapItems) {
      const values = Object.values(mapItems);

      return Math.ceil(Math.max(...values) / 10) * 10;
    },

    generateBarChartDataPessoasPorEstado() {
      const statesCount = {};

      this.listaPessoasAlcancadas.forEach((pessoa) => {
        const estado = this.estados[pessoa.estado].nome;
        if (statesCount[estado]) {
          statesCount[estado]++;
        } else {
          statesCount[estado] = 1;
        }
      });

      this.barChartOptionsPorEstado.xaxis.categories = Object.keys(statesCount);
      this.barChartSeriesPorEstado[0].data = Object.values(statesCount);
    },

    excluir(item) {
      this.$refs.confirm
        .open("Excluir Pessoa", item.nome, "Você tem certeza?", {})
        .then((confirm) => {
          if (confirm) {
            let payload = {
              projetoId: parseInt(this.$route.params.projetoId),
              pessoaAlcancadaId: item.id,
            };
            this.deletePessoaAlcancada(payload);
          }
        });
    },
  },
  computed: {
    listaPessoasAlcancadas() {
      return this.$store.getters["pessoaAlcancada/byProjetoId"](
        parseInt(this.$route.params.projetoId)
      );
    },
    estados() {
      return this.$store.getters["enums/estados"];
    },
    generos() {
      return this.$store.getters["enums/generos"];
    },

    pessoasPorEstado() {
      const statesCount = {};

      this.listaPessoasAlcancadas.forEach((pessoa) => {
        const state = this.estados[pessoa.estado].nome;
        if (statesCount[state]) {
          statesCount[state]++;
        } else {
          statesCount[state] = 1;
        }
      });

      return statesCount;
    },

    pessoasPorGenero() {
      const mapCount = {};

      console.log(Object.values(this.generos)[0].nome);

      Object.values(this.generos).forEach((genero) => {
        mapCount[genero.nome] = 0;
      });

      this.listaPessoasAlcancadas.forEach((pessoa) => {
        const state = this.generos[pessoa.genero].nome;
        mapCount[state]++;
      });

      return mapCount;
    },

    pessoasPorIdade() {
      const mapCount = {
        "0-10": 0,
        "11-20": 0,
        "21-30": 0,
        "31-40": 0,
        "41-50": 0,
        "51-60": 0,
        "61+": 0,
      };

      this.listaPessoasAlcancadas.forEach((pessoa) => {
        const idade = pessoa.idade;
        if (idade >= 0 && idade <= 10) {
          mapCount["0-10"]++;
        } else if (idade >= 11 && idade <= 20) {
          mapCount["11-20"]++;
        } else if (idade >= 21 && idade <= 30) {
          mapCount["21-30"]++;
        } else if (idade >= 31 && idade <= 40) {
          mapCount["31-40"]++;
        } else if (idade >= 41 && idade <= 50) {
          mapCount["41-50"]++;
        } else if (idade >= 51 && idade <= 60) {
          mapCount["51-60"]++;
        } else {
          mapCount["61+"]++;
        }
      });

      return mapCount;
    },

    isPermissao() {
      return this.$store.getters["auth/isAdministrador"];
    },
  },

  created() {
    Promise.all([
      this.fetchPessoasAlcancadasByProjeto(this.$route.params.projetoId),
    ]).then(() => {
      // POR ESTADO

      this.mockPessoas.apexBarPorEstado.options.xaxis.categories = Object.keys(
        this.pessoasPorEstado
      );
      this.mockPessoas.apexBarPorEstado.series[0].data = Object.values(
        this.pessoasPorEstado
      );

      this.mockPessoas.apexPiePorEstado1.series = Object.values(
        this.pessoasPorEstado
      ).map((count) => (count / this.listaPessoasAlcancadas.length) * 100);

      this.mockPessoas.apexPiePorEstado1.options.labels = Object.keys(
        this.pessoasPorEstado
      );

      //this.mockPessoas.apexBarPorEstado.options.yaxis.max =
      // this.maximo(this.pessoasPorEstado) * 2;

      //console.log("this.maximo() ", this.maximo(this.pessoasPorEstado));

      // POR GENERO

      this.mockPessoas.apexBarPorGenero.options.xaxis.categories = Object.keys(
        this.pessoasPorGenero
      );
      this.mockPessoas.apexBarPorGenero.series[0].data = Object.values(
        this.pessoasPorGenero
      );

      Object.entries(this.pessoasPorGenero).map(([state, count]) => ({
        x: state,
        y: (count / 100) * 100,
      }));

      this.mockPessoas.apexPiePorGenero.series = Object.values(this.pessoasPorGenero).map(
        (count) => (count / this.listaPessoasAlcancadas.length) * 100
      );

      this.mockPessoas.apexPiePorGenero.options.labels = Object.keys(
        this.pessoasPorGenero
      );

      // POR IDADE

      this.mockPessoas.apexBarPorIdade.options.xaxis.categories = Object.keys(
        this.pessoasPorIdade
      );
      this.mockPessoas.apexBarPorIdade.series[0].data = Object.values(
        this.pessoasPorIdade
      );

      this.asyncDataStatus_fetched();
    });
  },

  mounted() {
    this.generateBarChartDataPessoasPorEstado();
  },
};
</script>
